import { icon } from "./icons.js";
import { explorerTxUrl, shortTxHash } from "./explorer.js";

/**
 * Explorer link + copy control for a transaction hash (Portfolio / tape / banner).
 * @param {string | null | undefined} hash
 * @param {{ keep?: number }} [opts]
 * @returns {HTMLElement}
 */
export function renderTxCell(hash, { keep = 10 } = {}) {
  const wrap = document.createElement("div");
  wrap.className = "tx-cell";
  if (!hash) {
    wrap.textContent = "-";
    return wrap;
  }
  const clean = String(hash).replace(/^0x/i, "");
  const url = explorerTxUrl(clean);
  if (url) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.textContent = shortTxHash(clean, keep);
    a.title = "Open in Dusk explorer";
    wrap.append(a);
    wrap.append(icon("external", { size: 14 }));
  } else {
    wrap.textContent = shortTxHash(clean, keep);
  }
  const copyBtn = document.createElement("button");
  copyBtn.type = "button";
  copyBtn.className = "copy-icon-btn";
  copyBtn.title = "Copy hash";
  copyBtn.append(icon("copy", { size: 14 }));
  copyBtn.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(clean);
    } catch {
      /* ignore */
    }
  });
  wrap.append(copyBtn);
  return wrap;
}
